function productAccordion(){
  $('.product__accordion-title').on('click', function() {
    const $this = $(this);
    $this.next('.product__accordion-content').stop(true).slideToggle().siblings('.product__accordion-content').slideUp();
    $this.toggleClass('active').siblings('.product__accordion-title').removeClass('active')
  })

}

export default productAccordion();



// WEBPACK FOOTER //
// ../markup/assets/js/product-accordion.js